// phonics_data_lt01.js
// Letter Teams L01 - L1 Long Vowel a - Magic e - CVCe
// 路由：/phonics/lt01

const MEDIA_BASE = '/media/phonics/lt01';
const V = 'v1';

export const letterDataLt01 = {
  id: 'lt01',
  letter: 'L01',
  title: 'L1 Long Vowel a - Magic e - CVCe',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P4-P6: 三段故事（story-video-left-lines-right）
  // lines 只用 en + audioEn（无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "Green had a cake.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "I will give it to Kate.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Can we go too?", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Yes, let's go!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "The pals went out.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Let's have a race.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Let's race to Kate.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
        { en: "Oh, no!", audioEn: `${MEDIA_BASE}/story1_8.mp3?${V}` },
        { en: "The pals ran into a maze.", audioEn: `${MEDIA_BASE}/story1_9.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Let's go there.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "But they did not see Kate.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "They saw a cave.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Let's go there.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "They saw a lake.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Look!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "Kate was in the maze!", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "The pals ran to her.", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Kate!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "This cake is for you!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Thank you!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
      ],
    },
  ],
};
